import React from 'react'
import PropType from 'prop-types'
import ReactDOM from 'react-dom'

export const usePrint = () => {
  const [print, setPrint] = React.useState(false)
  React.useEffect(() => {
    if (print) {
      setPrint(false)
      window.print()
    }
  }, [print])
  return [print, setPrint]
}

export function PrintRoot({ children }) {
  return (
    <>
      <style>
        {`
        @media print {
          #root {
            display: none;
          }
          #print-view {
            display: block;
          }
        }
        @media screen {
          #print-view {
            display: none;
          }
        }`}
      </style>
      { children }
    </>
  )
}

PrintRoot.propTypes = {
  children: PropType.node.isRequired,
}

export const Print = ({ children, className, appendNodeId }) => {
  const printView = document.getElementById('print-view')
  const el = document.createElement('div')
  el.className = className || ''
  React.useEffect(() => {
    if (appendNodeId) {
      const graph = document.getElementsByTagName('canvas')[0]
      if (graph) el.appendChild(graph)
    }
    printView.appendChild(el)
    return () => {
      if (appendNodeId) {
        const vis = document.getElementsByClassName('vis-network')[0]
        const graph = document.getElementsByTagName('canvas')[0]
        vis.appendChild(graph)
      }
      printView.removeChild(el)
    }
  }, [el, printView, appendNodeId])
  return ReactDOM.createPortal(children, el)
}

export function PrintView({
  children, appendNodeId, className,
}) {
  return (
    <Print appendNodeId={appendNodeId} className={className}>
      { children }
    </Print>
  )
}

PrintView.defaultProps = {
  appendNodeId: null,
  children: null,
  className: '',
  // print: false,
}

PrintView.propTypes = {
  appendNodeId: PropType.string,
  children: PropType.node,
  className: PropType.string,
  // print: PropType.bool,
}
